<template>
  <div class="container-fluid">
    <div class="contents setting">
      <tab />
      <b-form @submit="onSubmit">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-1"
            role="tabpanel"
            aria-labelledby="pills-1-tab"
          >
            <div class="row g-0 table-type header-col">
              <div class="col-sm-4">
                {{ $t("title.common.id") }}
              </div>
              <div class="col-sm-8">
                {{ form.id }}
              </div>

              <div class="col-sm-4">
                {{ $t("title.common.email") }}
              </div>
              <div class="col-sm-8">
                {{ form.email }}
              </div>

              <div class="col-sm-4">
                {{ $t("title.common.location") }}
              </div>
              <div class="col-sm-8">
                {{ form.nickname }}
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.setting") }}</span>
              </div>
              <div class="col-sm-8">
                <div class="row g-2">
                  <div class="col-sm-4">
                    <select
                      id="fieldunit"
                      v-model="form.fieldunit"
                      requried
                    >
                      <option value="" disabled>
                        {{ $t("filter.setting.fairway") }}
                      </option>
                      <option value="1" :selected="form.fieldunit === '1'">
                        {{ $t("filter.setting.miter") }}
                      </option>
                      <option value="2" :selected="form.fieldunit === '2'">
                        {{ $t("filter.setting.yard") }}
                      </option>
                      <option value="3" :selected="form.fieldunit === '3'">
                        {{ $t("filter.setting.feet") }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <select
                      id="greenunit"
                      v-model="form.greenunit"
                      required
                    >
                      <option value="" disabled>
                        {{ $t("filter.setting.green") }}
                      </option>
                      <option value="1" :selected="form.greenunit === '1'">
                        {{ $t("filter.setting.miter") }}
                      </option>
                      <option value="2" :selected="form.greenunit === '2'">
                        {{ $t("filter.setting.yard") }}
                      </option>
                      <option value="3" :selected="form.greenunit === '3'">
                        {{ $t("filter.setting.feet") }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <select
                      id="speedunit"
                      v-model="form.speedunit"
                      required
                    >
                      <option value="" disabled>
                        {{ $t("filter.setting.speed") }}
                      </option>
                      <option value="1" :selected="form.speedunit === '1'">
                        {{ $t("filter.setting.km_h") }}
                      </option>
                      <option value="2" :selected="form.speedunit === '2'">
                        {{ $t("filter.setting.mile_h") }}
                      </option>
                      <option value="3" :selected="form.speedunit === '3'">
                        {{ $t("filter.setting.m_s") }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">
                <span class="required">{{
                  $t("title.setting.last_name")
                }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="firstname"
                  :placeholder="
                    $t('text.setting.you_can_enter_only_20_characters')
                  "
                  v-model="form.firstname"
                  maxlength="30"
                  required
                />
              </div>

              <div class="col-sm-4">
                <span class="required">{{
                  $t("title.setting.first_name")
                }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="lastname"
                  :placeholder="
                    $t('text.setting.you_can_enter_only_20_characters')
                  "
                  v-model="form.lastname"
                  maxlength="30"
                  required
                />
              </div>

              <div class="col-sm-4">
                {{ $t("title.setting.location_image") }}
              </div>
              <div class="col-sm-8">
                <div class="d-flex flex-column flex-sm-row">
                  <div class="flex-shrink-0 me-0 me-sm-2 mb-2 mb-sm-0">
                    <img
                      :src="form.shop_photo_url | get_img"
                      class="border rounded-circle"
                    />
                  </div>
                  <div class="flex-grow-1">
                    <b-form-file
                      v-model="file1"
                      ref="file1"
                      :state="Boolean(file1)"
                      :placeholder="$t('text.setting.select_file_or_drop')"
                      :drop-placeholder="$t('text.setting.drop_it_here')"
                      @change="fileSelect"
                    >
                    </b-form-file>
                  </div>
                </div>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.country") }}</span>
              </div>
              <div class="col-sm-8">
                <select
                  v-model="form.countryno"
                  required
                  @change="change_country"
                >
                  <option value="0" disabled>
                    {{ $t("title.common.country") }}
                  </option>
                  <option
                    :value="val.countryno"
                    v-for="(val, index) in countrylist"
                    :key="index + 's'"
                  >
                    {{ val.countryname }}
                  </option>
                </select>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.state") }}</span>
              </div>
              <div class="col-sm-8">
                <select
                  v-model="form.statesno"
                  required
                  @change="change_state"
                >
                  <option disabled>{{ $t("filter.setting.state") }}</option>
                  <option
                    :value="val.statesno"
                    v-for="(val, index) in stateslist"
                    :key="index + 's'"
                  >
                    {{ val.statesdesc }}
                  </option>
                </select>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.city") }}</span>
              </div>
              <div class="col-sm-8">
                <select v-model="form.city" required>
                  <option disabled>{{ $t("filter.setting.city") }}</option>
                  <option
                    :value="city.cityname"
                    v-for="(city, index) in citylist"
                    :key="index + 'c'"
                  >
                    {{ city.cityname }}
                  </option>
                </select>
              </div>

              <div class="col-sm-4">
                <span class="required">{{
                  $t("title.setting.time_zone")
                }}</span>
              </div>
              <div class="col-sm-8">
                <select v-model="form.timezone" required>
                  <option
                    v-for="(val, index) in timezonelist"
                    :value="val.timezonelist_pk"
                    :key="index + 't'"
                  >
                    {{ val.timezonelist_name }} (UTC
                    {{
                      val.timezonelist_offset >= 0
                        ? "+" + val.timezonelist_offset
                        : val.timezonelist_offset
                    }}:00)
                  </option>
                </select>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.address") }}</span>
              </div>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    name="address"
                    v-model="form.address"
                    @keyup="address_reset()"
                    maxlength="50"
                    required
                  />
                  <button
                    class="btn btn-primary btn-lg icon-check"
                    type="button"
                    @click="address_check(form.state, form.city, form.address)"
                  >
                    {{ $t("button.common.address_check") }}
                  </button>
                  <input type="hidden" v-model="form.address_lat" />
                  <input type="hidden" v-model="form.address_lng" />
                </div>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.common.map") }}</span>
              </div>
              <div class="col-sm-8">
                <div class="col" id="map" style="height: 300px;"></div>
              </div>

              <div class="col-sm-4">
                <span class="required">{{
                  $t("title.setting.post_code")
                }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="zipcode"
                  v-model="form.zipcode"
                  maxlength="10"
                  required
                />
              </div>

              <div class="col-sm-4">
                {{ $t("title.setting.email_agree") }}
              </div>
              <div class="col-sm-8">
                <div class="d-flex">
                  <input
                    class="form-check-input flex-shrink-0"
                    type="checkbox"
                    id="emailagree"
                    name="emailagree"
                    v-model="check_form.emailagree"
                  />
                  <label class="form-check-label" for="emailagree">{{
                    $t("text.setting.email_agree")
                  }}</label>
                </div>
              </div>

              <div class="col-sm-4">
                <span class="required">{{ $t("title.setting.phone") }}</span>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="phone"
                  v-model="form.phone"
                  maxlength="30"
                  required
                />
              </div>

              <div class="col-sm-4">
                {{ $t("title.setting.fax") }}
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="fax"
                  v-model="form.fax"
                  maxlength="30"
                />
              </div>

              <div class="col-sm-4">
                {{ $t("title.setting.homepage") }}
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  name="website"
                  v-model="form.website"
                  maxlength="30"
                />
              </div>
            </div>

            <div class="btn-bottom-wrapper">
              <b-button
                size="xl"
                variant="primary"
                :aria-label="$t('button.common.save')"
                type="submit"
                >{{ $t("button.common.save") }}</b-button
              >
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/setting";
import tab from "@/components/setting/Tab";

export default {
  name: "Profile",
  components: {
    tab,
  },
  data() {
    return {
      form: {
        id: "",
        nickname: "",
        email: "",
        membertype: "",
        timezone: 0,
        daylighttime: "",
        fieldunit: "",
        greenunit: "",
        speedunit: "",
        emailagree: "",
        firstname: "",
        lastname: "",
        state: "",
        city: "",
        address: "",
        zipcode: "",
        phone: "",
        fax: "",
        website: "",
        addressoverlap: 0,
        address_lat: "",
        address_lng: "",
        filename: "",
        shop_photo_url: "",
        countryno: "0",
        statesno: "",
      },

      check_form: [
        {
          daylighttime: false,
          emailagree: true,
          address_chk: "y",
        },
      ],

      timezonelist: [],
      countrylist: [],
      stateslist: [],

      citylist: [],
      timezone_arr: [
        -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8,
        9, 10, 11,
      ],
      file1: null,
      map: null,
      mapCenter: null,
    };
  },
  methods: {
    initMap(address_lat, address_lng) {
      console.log("initMapthis.form", address_lat);
      console.log("initMapthis.form", address_lng);

      if (document.getElementById("map"))
        this.map = new google.maps.Map(document.getElementById("map"), {
          //getElementById로 map id 속성의 요소를 가져온다.
          center: {
            lat: address_lat,
            lng: address_lng,
          }, //center로 할 위도, 경도를 지정한다.
          zoom: 17, //zoom size를 지정.
          maxZoom: 20,
          minZoom: 3,
          streetViewControl: true,
          mapTypeControl: true,
          fuulscreenControl: true,
          zoomControl: true,
        });
      this.setMarker(
        {
          lat: address_lat,
          lng: address_lng,
        },
        "ce"
      );
    },
    setMarker(Points, Label) {
      //지도에 마커를 찍는 함수.
      const markers = new google.maps.Marker({
        position: Points,
        map: this.map,
        label: {
          text: Label,
          color: "#FFF",
        },
      });
    },
    fileSelect(e) {
      // alert(e.dataTransfer.files[0]);
      if (e.dataTransfer) {
        this.form.filename = e.dataTransfer.files[0];
      } else {
        this.form.filename = e.target.files[0];
      }
    },
    get_owneview() {
      ax.get_owneview((flag, data) => {
        if (flag) {
          this.form = data.ownerinfo;
          if (this.form.countryno > 0) this.get_stateslist();
          this.get_citylist();
          console.log("this.form", this.form);
          // alert(data.ownerinfo[0].address_lat);
          this.check_form.daylighttime = this.form.daylighttime === "1";
          this.check_form.emailagree = this.form.emailagree === "1";

          this.initMap(
            parseFloat(data.ownerinfo.address_lat),
            parseFloat(data.ownerinfo.address_lng)
          );
        } else {
          alert(data);
        }
      });
    },

    get_citylist() {
      ax.get_citylist(this.form.statesno, (flag, data) => {
        if (flag) {
          this.citylist = data.citylist;
        } else {
          if (data !== "no data") alert(data);
        }
      });
    },

    address_reset() {
      this.check_form.address_chk = "n";
    },
    address_check(statesno, city, address) {
      if (address === "") {
        alert(this.$i18n.t("alert.setting.enter_address"));
        return false;
      }

      let statesname = "";
      if (this.stateslist.find((v) => v.statesno == statesno))
        statesname = this.stateslist.find(
          (v) => v.statesno == statesno
        ).statesname;
      console.log("statesname", this.stateslist);
      var addresslist = address.concat(" ", statesname, " ", city);

      ax.address_check(addresslist, (flag, data) => {
        if (flag) {
          //  alert(data.addressinfo[0].lat);
          //  alert(data.addressinfo[0].lng);
          alert(this.$i18n.t("alert.setting.address_confirmed"));
          this.form.address_lat = data.addressinfo.lat;
          this.form.address_lng = data.addressinfo.lng;
          this.check_form.address_chk = "y";
          // alert(this.form.address_lat);
          // alert(this.form.address_lng);
          this.initMap(
            parseFloat(data.addressinfo.lat),
            parseFloat(data.addressinfo.lng)
          );
        } else {
          if (data !== "no data") alert(data.message);
          this.check_form.address_chk = "n";
        }
      });
    },
    onSubmit(event) {
      console.log("this.form.filename", this.form);
      event.preventDefault();
      this.form.daylighttime =
        this.check_form.daylighttime === true ? "1" : "0";
      this.form.emailagree = this.check_form.emailagree === true ? "1" : "0";

      if (this.form.fieldunit === "") {
        alert(this.$i18n.t("alert.setting.select_field_unit"));
        return false;
      }
      if (this.form.greenunit === "") {
        alert(this.$i18n.t("alert.setting.select_green_unit"));
        return false;
      }
      if (this.form.speedunit === "") {
        alert(this.$i18n.t("alert.setting.select_speed_unit"));
        return false;
      }
      if (this.form.firstname === "") {
        alert(this.$i18n.t("alert.setting.enter_firstname"));
        return false;
      }

      let firstNamechk = /^[a-zA-Z0-9]{3,30}$/; // 문자 숫자만
      if (!firstNamechk.test(this.form.firstname)) {
        alert(this.$i18n.t("alert.setting.first_name_must_be_entered"));
        return false;
      }

      if (this.form.lastname === "") {
        alert(this.$i18n.t("alert.setting.enter_lastname"));
        return false;
      }

      if (this.form.statesno === "") {
        alert(this.$i18n.t("alert.setting.select_state"));
        return false;
      }
      if (this.form.city === "") {
        alert(this.$i18n.t("alert.setting.select_city"));
        return false;
      }
      if (this.form.address === "") {
        alert(this.$i18n.t("alert.setting.enter_address"));
        return false;
      }

      if (this.check_form.address_chk === "n") {
        alert(this.$i18n.t("alert.setting.check_address"));
        this.form.addressoverlap = 0;
        return false;
      }
      this.form.addressoverlap = 1;

      if (this.form.zipcode === "") {
        alert(this.$i18n.t("alert.setting.check_address"));
        return false;
      }
      if (this.form.phone === "") {
        alert(this.$i18n.t("alert.setting.enter_phone_number"));
        return false;
      }
      //if (this.form.fax === "") {
      //  alert(this.$i18n.t("alert.setting.enter_fax_number"));
      //  return false;
      //}
      // if (this.form.website === "") {
      //   alert("홈페이지를 입력하세요.");
      //   return false;
      // }

      this.set_owneredit();
    },
    set_owneredit() {
      console.log("this.form", this.form);

      ax.set_owneredit(this.form, (flag, data) => {
        if (flag) {
          this.get_owneview();
          alert(data.message);
        } else {
          /*this.$notify({
            group: 'alert',
            type: 'warn',
            title: '경고',
            text: data
          })*/
          // alert(data)
          alert(data.message);
          return false;
        }
      });
    },
    change_state() {
      this.get_citylist();
    },
    change_country() {
      this.form.statesno = "";
      this.form.city = "";
      this.form.address = "";
      this.get_stateslist();
    },
    get_countrylist() {
      ax.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },
    get_timezonelist() {
      ax.get_timezonelist((flag, data) => {
        if (flag) {
          this.timezonelist = data.timezonelist;
        } else {
          alert(data);
        }
      });
    },
    get_stateslist() {
      ax.get_stateslist(this.form.countryno, (flag, data) => {
        if (flag) {
          this.stateslist = data.stateslist;
          console.log("states_list", this.stateslist);
        } else {
          alert(data);
        }
      });
    },
  },
  created() {
    this.get_owneview();
    this.get_countrylist();
    this.get_timezonelist();

    // this.get_stateslist();
    // this.get_citylist();
  },
  watch: {
    // "form.countryno"() {
    //   this.get_stateslist();
    //   console.log("변경!", this.form.countryno);
    // },
    // "form.statesno"() {
    //   this.get_citylist();
    //   console.log("변경!", this.form.statesno);
    // },
  },
};
</script>
